/**
 * @synopsis 判断是否为移动端
 * @returns {boolean} 是否为移动端
 */
function isMobile() {
  if ((/HarmonyOS|Android|webOS|iPhone|iPod|BlackBerry|SymbianOS|Windows Phone|iPad|HeyTapBrower/i).test(navigator.userAgent)) {//HeyTapBrower oppo手机
    return true;
  }
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    // iOS13+ IPD
    return true;
  }
  return false;
}

export default isMobile;
